exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".rct-overlay{position:fixed;left:-100%;top:0;width:100%;height:100%;opacity:0;filter:alpha(opacity=0);z-index:1050;background-color:rgba(0,0,0,.2);-webkit-transition:opacity .4s;transition:opacity .4s}.rct-overlay.active{left:0;opacity:1;filter:alpha(opacity=100)}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?localIdentName=[hash:base64:8]!./~/less-loader!./src/themes/pure/overlay.less
 ** module id = 203
 ** module chunks = 0
 **/